import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/walletAdvanced',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletAdvanced" */ '~/pages/WalletAdvanced'
        )
    ),
  },
  {
    path: '/walletAdvanced/quick',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletAdvanced-fast" */ '~/pages/WalletAdvanced/Fast'
        )
    ),
  },
  {
    path: '/walletAdvanced/oldUserRecharge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletAdvanced-OldUserRecharge" */ '~/pages/WalletAdvanced/OldUserRecharge'
        )
    ),
  },
  {
    path: '/walletAdvanced/extra',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletAdvanced-extra" */ '~/pages/WalletAdvanced/RechargeExtra'
        )
    ),
  },
  {
    path: '/walletAdvanced/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletAdvanced-Record" */ '~/pages/Bill'
        )
    ),
  },
  // 支付成功结果页面（订单不一定成功）
  {
    path: '/walletAdvanced/success/:order_id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletAdvanced/result/success'
        )
    ),
  },
  // 支付失败页面
  {
    path: '/walletAdvanced/fail/:order_id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletAdvanced/result/fail'
        )
    ),
  },
  // codaPay 结果页面
  {
    // path: '/walletAdvanced/coda/result/:transition_id/:order_id',
    path: '/walletAdvanced/coda/result',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletAdvanced/channels/codapay/result'
        )
    ),
  },
  // codaPay 支付页面
  {
    path: '/walletAdvanced/coda/:order_id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Wallet-airwallex" */ '~/pages/WalletAdvanced/channels/codapay/index'
        )
    ),
  },

  // 我的卡券页面
  {
    path: '/walletAdvanced/ticket',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-WalletAdvanced-ticket" */ '~/pages/WalletAdvanced/Ticket'
        )
    ),
  },
] as RouteConfig[]
